<div class="form-check" [ngClass]="button.selected ? 'form-check-selected' : 'form-check-unselected'">
  <label for="button{{button.value}}" class="container"><input type="radio" id="button{{button.value}}" [checked]="button.selected" (click)="handleButtonClick()">
    <span [ngClass]="button.disabled ? 'disabled-button-title' : ''"><ng-content></ng-content>{{button.name ? button.name : ''}}</span>
    <span [ngClass]="button.disabled ? 'disabled-checkmark' : 'checkmark'"></span>
  </label>
</div>